import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { BaseTabs, OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { JobCatalogEnumsJobCatalogTreeNodeTypesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { TreeNode } from 'modules/cost_centers/components/CostCentersStructure/types'

import { CostCentersStructurePreview } from './Structure'
import { CostCenterAssignmentsPreview } from './Assignments'

const CostCentersPreview = ({
  treeArray,
  jobStructure,
  expandJobStructure,
}: {
  treeArray: TreeNode[]
  expandJobStructure: boolean
  jobStructure?: JobCatalogEnumsJobCatalogTreeNodeTypesEnum
}) => {
  const [previewTab, setPreviewTab] = useState<string>('structure')

  if (!expandJobStructure) {
    return (
      <Box justifyContent="center" alignItems="center" flexGrow>
        <OneEmptyState
          emoji="🍑"
          title={i18n.t('finance.cost_centers_structure.preview.empty.no_dimension.title')}
          description={i18n.t(
            'finance.cost_centers_structure.preview.empty.no_dimension.description'
          )}
        />
      </Box>
    )
  } else if (!jobStructure) {
    return (
      <Box justifyContent="center" alignItems="center" flexGrow>
        <OneEmptyState
          emoji="💼"
          title={i18n.t('finance.cost_centers_structure.preview.empty.no_hierarchy.title')}
          description={i18n.t(
            'finance.cost_centers_structure.preview.empty.no_hierarchy.description'
          )}
        />
      </Box>
    )
  }

  return (
    <>
      <BaseTabs
        tabs={[
          {
            index: true,
            id: 'structure',
            onClick: () => setPreviewTab('structure'),
            label: i18n.t('finance.cost_centers_structure.preview.tabs.structure'),
          },
          {
            id: 'assignments',
            onClick: () => setPreviewTab('assignments'),
            label: i18n.t('finance.cost_centers_structure.preview.tabs.assignments'),
          },
        ]}
      />
      {previewTab === 'structure' && (
        <CostCentersStructurePreview
          treeArray={treeArray}
          jobStructure={jobStructure}
          expandJobStructure={expandJobStructure}
        />
      )}
      {previewTab === 'assignments' && <CostCenterAssignmentsPreview />}
    </>
  )
}

export { CostCentersPreview }
